import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const EmptyNotificationMessage = () => {
  const navigate = useNavigate();

  return (
    <Grid textAlign="center" mt={5}>
      <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
        連絡が一件もありません
      </Typography>
      <Typography>
        連絡が追加されると
        <br />
        こちらに表示されます
      </Typography>
      <Button
        onClick={() => navigate('/patient/top')}
        className="bg-primary rounded py-3 text-base"
        variant="contained"
        sx={{ marginTop: '20px', width: '50%' }}
      >
        TOPへ戻る
      </Button>
    </Grid>
  );
};

export default EmptyNotificationMessage;
